import { createSlice } from "@reduxjs/toolkit";
import authService from "services/authService";
import { setUserData } from "./userSlice";

export const submitLogin = (login, redirectUrl) => async (dispatch) => {
	try {
		dispatch(setSubmitting(true));
		const result = await authService.signInWithEmailAndPassword(login);
		dispatch(loginSuccess());
		dispatch(setUserData(result, redirectUrl));
	} catch (error) {
		console.error(error);
		const { status, data } = error.response;
		return dispatch(loginError({ status, data }));
	} finally {
		dispatch(setSubmitting(false));
	}
};

const initialState = {
	success: false,
	error: null,
	isSubmitting: false,
};

const loginSlice = createSlice({
	name: "auth/login",
	initialState,
	reducers: {
		loginSuccess: (state) => {
			state.success = true;
			state.error = null;
		},
		loginError: (state, action) => {
			state.success = false;
			state.error = action.payload;
		},
		setSubmitting: (state, action) => {
			state.isSubmitting = action.payload;
		},
		resetLoginState: () => initialState,
	},
	extraReducers: {},
});

export const {
	loginSuccess,
	loginError,
	setSubmitting,
	resetLoginState,
} = loginSlice.actions;

export default loginSlice.reducer;
